import React from "react";
import axios from "axios";
import logo from "./assets/ezice.png";
import "./NavBar.css";
import { Redirect } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";

const PRIMARY_LINKS = [
  ["/supplychain", "Orders"],
  ["/inventory", "Inventory"],
  ["/subs", "Subs"],
  ["/upgrades", "Upgrades"],
  ["/warehouse", "Warehouse"],
  ["/reports", "Reports"],
];

const MORE_LINKS = [
  [
    "Customers",
    [
      ["/draftorder", "Draft order"],
      ["/announcements", "Announcements"],
      ["/documentemails", "Document emails"],
    ],
  ],
  [
    "Tools",
    [
      ["/snapshots", "Snapshots"],
      ["/scripts", "Scripts"],
    ],
  ],
];

function isCurrent(path) {
  return window.location.pathname.startsWith(path);
}

function initials(name) {
  return (name || "")
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      shouldRedirect: false,
      taskCount: 0,
    };
  }

  async componentDidMount() {
    try {
      const currentUser = (await axios.get("/api/users/current")).data;

      this.setState({ currentUser });
      this.fetchTaskCount();
    } catch (e) {
      if (e.response.status === 401) {
        this.setState({ shouldRedirect: true });
      } else {
        console.error(e);
      }
    }
  }

  fetchTaskCount = async () => {
    try {
      const tasks = (await axios.get("/api/tasks")).data;
      this.setState({ taskCount: tasks.length });
    } catch (e) {
      console.error(e);
    }
  };

  handleSignout = async () => {
    await axios.delete("/api/signout/");

    deleteCookie("ez_t");

    window.location = "/";
  };

  render() {
    if (this.state.shouldRedirect) {
      return <Redirect to="/signin" />;
    } else {
      const { currentUser, taskCount } = this.state;
      const moreIsCurrent = MORE_LINKS.some(([, links]) =>
        links.some(([path]) => isCurrent(path))
      );

      return (
        <nav className="navigation-bar">
          <a href="/" className="navigation-logo-link">
            <img className="navigation-logo" src={logo} alt="EZ ICE" />
          </a>
          <div className="navigation-links">
            {PRIMARY_LINKS.map(([path, label]) => (
              <a
                key={path}
                href={path}
                className={
                  isCurrent(path)
                    ? "navigation-link navigation-link-current"
                    : "navigation-link"
                }
              >
                {label}
              </a>
            ))}
            <Dropdown className="navigation-more">
              <Dropdown.Toggle
                as="button"
                className={
                  moreIsCurrent
                    ? "navigation-link navigation-link-current"
                    : "navigation-link"
                }
              >
                More
              </Dropdown.Toggle>
              <Dropdown.Menu className="navigation-menu">
                {MORE_LINKS.map(([group, links], groupIdx) => (
                  <React.Fragment key={group}>
                    {groupIdx > 0 && <Dropdown.Divider />}
                    <Dropdown.Header>{group}</Dropdown.Header>
                    {links.map(([path, label]) => (
                      <Dropdown.Item
                        key={path}
                        href={path}
                        active={isCurrent(path)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </React.Fragment>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="navigation-right">
            <a
              href="/tasks"
              className={
                isCurrent("/tasks")
                  ? "navigation-tasks navigation-link-current"
                  : "navigation-tasks"
              }
            >
              Tasks
              {taskCount > 0 && (
                <span className="navigation-task-count">{taskCount}</span>
              )}
            </a>
            <Dropdown>
              <Dropdown.Toggle as="button" className="navigation-avatar-toggle">
                {currentUser?.picture_url ? (
                  <img
                    className="navigation-avatar"
                    src={currentUser.picture_url}
                    alt=""
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <span className="navigation-avatar">
                    {initials(currentUser?.name)}
                  </span>
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu className="navigation-menu" align="right">
                {currentUser && (
                  <div className="navigation-user">
                    <div>{currentUser.name}</div>
                    <div className="navigation-user-email">
                      {currentUser.email}
                    </div>
                  </div>
                )}
                <Dropdown.Divider />
                <Dropdown.Item as="button" onClick={this.handleSignout}>
                  Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </nav>
      );
    }
  }
}

function deleteCookie(name) {
  setCookie(name, "", -1);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default NavBar;
